import { create } from 'zustand';
import { ArrivalReceipt } from 'types';

interface ArrivalReceiptState {
  currentArrivalReceipt: ArrivalReceipt | null;
  setCurrentArrivalReceipt: (receipt: ArrivalReceipt | null) => void;
}

export const useArrivalReceiptStore = create<ArrivalReceiptState>((set) => ({
  currentArrivalReceipt: null,
  setCurrentArrivalReceipt: (receipt: ArrivalReceipt | null) =>
    set({ currentArrivalReceipt: receipt }),
}));
